import React from "react";
import BaseComponent from "../baseComponent";
import CategoriesComponent from "./advertisersComponent";
import Utility, {dispatchAction} from "../../utility";
import {connect} from "react-redux";
import {history} from "../../managers/history";
import {eventConstants, pathConstants} from "../../constants";
import categoryService from "../../services/category";

export class Categories extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        this.refreshList()
    }

    refreshList = async () => {
        this.props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(categoryService.getCategoryList(),);
        this.props.dispatchAction(eventConstants.HIDE_LOADER);
        console.log("===",res)
        if (!res || err)
            return Utility.apiFailureToast("Unable to fetch category");
        res.sort((a, b) => new Date(b.addedOn).getTime() - new Date(a.addedOn).getTime());
        this.setState({categoryList: res})
    };

    onAddNewAdvertiserClicked = () => {
        history.push(pathConstants.DASHBOARD_MENU.ADD_CATEGORIES);
    };

    render() {
        return (
            <CategoriesComponent
                state={this.state}
                refreshList={this.refreshList}
                onAddNewAdvertiserClicked={this.onAddNewAdvertiserClicked}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(Categories);
